import React, { Component } from "react";
import { Table, Col, Row } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

export default class MetricsLabView extends Component {
  render() {
    const { details } = this.props;

    const columns = [
      {
        title: "Total Investigations",
        key: "total_orders",
        dataIndex: "total_orders",
        align: "left",
        width: "30%",
        render: record => <div>{record || "--"}</div>
      },

      {
        title: "Latest Activity",
        dataIndex: "last_activity_date",
        key: "last_activity_date",
        align: "left",
        render: record => (
          <div>
            {record ? (
              <div>{moment(record).format("DD-MM-YYYY")}</div>
            ) : (
              <div>-</div>
            )}
          </div>
        )
      }
    ];

    let source = [];
    if (details && details.metrics) {
      source = [details.metrics];
    }

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.dashboard.metrics}
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              //onRowClick={record => navigateToClinicDetails(record.id)}
              columns={columns}
              dataSource={source}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
